import IncTitle from 'components/inc-title/inc-title.component';

const SectionInfoTitle = ({ title, ...rest }) => {
  return (
    <IncTitle variant="h6" mb={1} {...rest}>
      {title}
    </IncTitle>
  );
};

export default SectionInfoTitle;
